import { Text } from 'preact-i18n';
import { Match, Link } from 'preact-router/match';

import BackIcon from '@svg/Back.svg';
import style from './style.module.scss';

const showHeader = (path) => {
  if (!path) return false;
  return path.startsWith('/settings') || path.startsWith('/more') || path.startsWith('/patreon');
};

const isSettingsChild = (path) => {
  if (!path) return false;
  return path.startsWith('/settings/language') || path.startsWith('/settings/theme');
};

function Header() {
  return (
    <Match path="/">
      {({ path }) => showHeader(path) && (
      <div class={style.header}>
        <Link href={isSettingsChild(path) ? '/settings' : '/'} class={style.back} aria-label="Back">
          <BackIcon />
        </Link>
        <h2 class={style.title}>
          { path?.startsWith('/settings') && <Text id="general.settings">Settings</Text> }
          { path?.startsWith('/more') && <Text id="general.more">More</Text> }
          { path?.startsWith('/patreon') && 'Patreon' }
        </h2>
      </div>
      )}
    </Match>
  );
}

export default Header;
